"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardComponentModelSchema = void 0;
const zod_1 = require("zod");
const InferenceReports_1 = require("../InferenceReports");
const SPICE_1 = require("../SPICE");
exports.StandardComponentModelSchema = zod_1.z.object({
    modelId: zod_1.z.string(),
    isPassive: zod_1.z.boolean().optional(),
    parameterInferenceReport: zod_1.z.any().optional(),
    inferenceReport: InferenceReports_1.InferenceReportSchema.optional(),
    models: SPICE_1.ISubModelOptsSchema.array().optional(),
});
//# sourceMappingURL=StandardComponentModel.js.map